/* SNOOFLE global — reveal on scroll + post-signup scroll target */
(function () {
  function init() {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, { threshold: 0.12 });
      document.querySelectorAll('.snf-reveal').forEach(function (el) { io.observe(el); });
    } else {
      document.querySelectorAll('.snf-reveal').forEach(function (el) { el.classList.add('in'); });
    }
    if (window.location.search.indexOf('customer_posted=true') !== -1 && !window.__snfPopSuccess) {
      document.querySelectorAll('[data-snf-success]').forEach(function (el) {
        el.hidden = false;
        var wrap = el.closest('.snf-quiz, .snf-news');
        if (wrap) {
          wrap.querySelectorAll('form, .snf-quiz-steps, .snf-qprogress').forEach(function (x) { x.style.display = 'none'; });
        }
      });
      var target = document.querySelector('[data-snf-success]') || document.getElementById('quiz');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

  /* Smooth scroll for in-page links (PDP stars -> reviews) */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-snf-scroll]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').replace(/^#/, '');
    var t = id && document.getElementById(id);
    if (!t) return;
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    t.querySelectorAll('.snf-reveal').forEach(function (el) { el.classList.add('in'); });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });
})();

/* SNOOFLE calculator — 1 chew per 10kg */
(function () {
  function initCalc() {
    document.querySelectorAll('[data-snf-calc]').forEach(function (calc) {
      if (calc.dataset.snfInit) return;
      calc.dataset.snfInit = '1';
      var slider = calc.querySelector('[data-w-slider]');
      var label = calc.querySelector('[data-w-label]');
      var chewsEl = calc.querySelector('[data-chews]');
      var daysEl = calc.querySelector('[data-days]');
      var costEl = calc.querySelector('[data-cost]');
      var packCount = parseInt(calc.dataset.packCount, 10) || 60;
      var packPrice = parseInt(calc.dataset.packPrice, 10) || 0; /* pence */
      var cur = calc.dataset.currency || '£';
      function update() {
        var kg = parseInt(slider.value, 10);
        var chews = Math.max(1, Math.ceil(kg / 10));
        var days = Math.floor(packCount / chews);
        label.textContent = kg;
        chewsEl.textContent = chews;
        daysEl.textContent = days;
        if (packPrice > 0 && days > 0) {
          costEl.textContent = cur + (packPrice / 100 / days).toFixed(2);
        } else {
          costEl.textContent = '—';
        }
      }
      slider.addEventListener('input', update);
      update();
    });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initCalc); } else { initCalc(); }
})();

/* SNOOFLE sticky ATC — desktop: show after the buy box scrolls away.
   Mobile (<750px, 3 Nov): show from the first screen while the main button is out of view;
   while the buy box is still below, the button says "Buy now" and scrolls to the options. */
(function () {
  function initSticky() {
    var bar = document.querySelector('[data-snf-sticky]');
    if (!bar) return;
    bar.hidden = false;
    var buyBox = document.querySelector('.product-form__buttons, product-form');
    if (!buyBox || !('IntersectionObserver' in window)) { bar.classList.add('show'); return; }
    var mq = window.matchMedia('(max-width: 749px)');
    var go = bar.querySelector('[data-snf-sticky-go]');
    var label = go ? go.textContent : '';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var above = en.boundingClientRect.top < 0;
        var show = !en.isIntersecting && (above || mq.matches);
        bar.classList.toggle('show', show);
        bar.classList.toggle('is-below', !en.isIntersecting && !above);
        if (go) go.textContent = (!en.isIntersecting && !above) ? 'Buy now →' : label;
      });
    }, { threshold: 0 });
    io.observe(buyBox);
    /* keep the bar above Shopify's cookie banner while it is open */
    function pc() {
      var b = document.getElementById('shopify-pc__banner');
      var h = 0;
      if (b && b.getClientRects().length && getComputedStyle(b).display !== 'none' && getComputedStyle(b).visibility !== 'hidden') {
        h = Math.max(0, window.innerHeight - b.getBoundingClientRect().top);
      }
      document.documentElement.style.setProperty('--snf-pc-h', h + 'px');
    }
    pc();
    var tries = 0, t = setInterval(function () { pc(); if (++tries > 40) clearInterval(t); }, 500);
    document.addEventListener('click', function (e) { if (e.target.closest('#shopify-pc__banner, #shopify-pc__prefs')) setTimeout(pc, 300); });
    window.addEventListener('resize', pc);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initSticky); } else { initSticky(); }
})();

/* ===== SNF Buy-box plus: copy code + bundle selector ===== */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-snf-copy]');
    if(!btn) return;
    var code = btn.getAttribute('data-snf-copy');
    var done = function(){
      var tag = btn.parentElement.querySelector('.snf-bb-copied');
      if(tag){ tag.hidden = false; setTimeout(function(){ tag.hidden = true; }, 2000); }
    };
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(code).then(done).catch(done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code; document.body.appendChild(ta); ta.select();
      try{ document.execCommand('copy'); }catch(err){}
      document.body.removeChild(ta); done();
    }
  });

  document.addEventListener('change', function(e){
    var input = e.target.closest('.snf-bundle input[type="radio"]');
    if(!input) return;
    var wrap = input.closest('[data-snf-bundle]');
    var sectionId = wrap.getAttribute('data-snf-section');
    wrap.querySelectorAll('.snf-bundle__card').forEach(function(c){ c.classList.remove('is-active'); });
    input.closest('.snf-bundle__card').classList.add('is-active');
    var qty = document.getElementById('Quantity-' + sectionId);
    if(qty){
      qty.value = input.value;
      qty.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();

/* ===== SNF Subscribe & save toggle ===== */
document.addEventListener('change', function(e){
  var input = e.target.closest('.snf-sub input[type="radio"]');
  if(!input) return;
  var wrap = input.closest('[data-snf-sub]');
  wrap.querySelectorAll('.snf-sub__opt').forEach(function(o){ o.classList.remove('is-active'); });
  input.closest('.snf-sub__opt').classList.add('is-active');
  var hidden = wrap.querySelector('[data-snf-sub-input]');
  var freq = wrap.querySelector('[data-snf-sub-freq]');
  var sel = wrap.querySelector('[data-snf-sub-select]');
  if(freq) freq.hidden = !input.value;
  if(hidden) hidden.value = (input.value && sel) ? sel.value : input.value;
});
document.addEventListener('change', function(e){
  var sel = e.target.closest('[data-snf-sub-select]');
  if(!sel) return;
  var wrap = sel.closest('[data-snf-sub]');
  var hidden = wrap.querySelector('[data-snf-sub-input]');
  if(hidden) hidden.value = sel.value;
});

/* ===== SNF v13: AJAX add-to-cart for lightweight forms (home grid "+", cart upsell) ===== */
(function(){
  function sectionsFor(drawer){
    try { return drawer.getSectionsToRender().map(function(s){ return s.id; }); } catch(e){ return []; }
  }
  document.addEventListener('submit', function(e){
    var form = e.target.closest('.snf-pack-atc-form, .snf-upsell__form');
    if(!form) return;
    var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if(!drawer || !window.routes || !window.routes.cart_add_url) return; // fall back to normal submit
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    if(btn){ btn.disabled = true; btn.setAttribute('aria-busy','true'); }
    var fd = new FormData(form);
    fd.append('sections', sectionsFor(drawer).join(','));
    fd.append('sections_url', window.location.pathname);
    fetch(window.routes.cart_add_url, { method:'POST', headers:{ 'Accept':'application/javascript', 'X-Requested-With':'XMLHttpRequest' }, body: fd })
      .then(function(r){ return r.json(); })
      .then(function(json){
        if(json.status){ throw new Error(json.description || 'Could not add'); }
        if(typeof publish === 'function' && window.PUB_SUB_EVENTS){ publish(PUB_SUB_EVENTS.cartUpdate, { source:'snf-quick-add', productVariantId: fd.get('id'), cartData: json }); }
        if(drawer.setActiveElement) drawer.setActiveElement(document.activeElement);
        drawer.classList.remove('is-empty'); // first add into an empty cart: Dawn's is-empty grid hides the new line until reload
        drawer.renderContents(json);
      })
      .catch(function(){ form.submit(); })
      .finally(function(){ if(btn){ btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });
})();

/* ===== SNF v13: quiz deep-link (?concern=joints) preselects the concern step if present ===== */
(function(){
  var m = /[?&]concern=([a-z]+)/.exec(location.search);
  if(!m) return;
  document.addEventListener('DOMContentLoaded', function(){
    var el = document.querySelector('[data-answer="concern"][data-value="'+m[1]+'"]');
    if(el){ if(el.tagName==='INPUT'){ el.checked = true; el.dispatchEvent(new Event('change',{bubbles:true})); } else { el.click(); } }
  });
})();

/* ===== SNF unified buy box: subscribe vs one-time, one price on the button ===== */
(function(){
  function sync(box){
    var sid = box.getAttribute('data-section');
    var mode = (box.querySelector('input[name^="snf-mode-"]:checked') || {}).value || 'once';
    var sp = box.querySelector('[data-snf-sp]'), q = box.querySelector('[data-snf-qty]');
    var plan = box.querySelector('[data-snf-plan]');
    var chip = box.querySelector('.snf-buy__chip.is-active[data-qty]');
    var schip = box.querySelector('.snf-buy__chip.is-active[data-sub-qty]');
    var sq = schip ? schip.getAttribute('data-sub-qty') : '1';
    var qty = chip ? chip.getAttribute('data-qty') : '1';
    box.querySelectorAll('.snf-buy__card').forEach(function(c){ c.classList.toggle('is-active', c.getAttribute('data-mode') === mode); });
    var price;
    if (mode === 'sub') { sp.value = plan ? plan.value : ''; q.value = sq; price = box.getAttribute(sq === '2' ? 'data-p-sub2' : 'data-p-sub'); }
    else { sp.value = ''; q.value = qty; price = box.getAttribute('data-p' + qty); }
    var op = box.querySelector('[data-once-price]'); if (op) op.textContent = box.getAttribute('data-p' + qty);
    var btn = document.querySelector('#ProductSubmitButton-' + sid + ' > span');
    if (btn && !document.getElementById('ProductSubmitButton-' + sid).disabled) btn.textContent = 'Add to basket — ' + price;
    var st = document.querySelector('[data-snf-sticky-price]');
    if (st) st.textContent = price + (mode === 'sub' ? ' · subscription' : '');
  }
  document.addEventListener('click', function(e){
    var go = e.target.closest('[data-snf-sticky-go]'); if (!go) return;
    var box = document.querySelector('[data-snf-buy]');
    var bar = go.closest('[data-snf-sticky]');
    if (box && bar && bar.classList.contains('is-below')) {
      var y = box.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: y, behavior: 'smooth' });
      box.classList.remove('snf-pulse'); void box.offsetWidth; box.classList.add('snf-pulse');
      return;
    }
    var main = box ? document.getElementById('ProductSubmitButton-' + box.getAttribute('data-section')) : document.querySelector('product-form button[type=submit]');
    if (main) main.click();
  });
  document.addEventListener('change', function(e){
    var box = e.target.closest('[data-snf-buy]'); if (box) sync(box);
  });
  document.addEventListener('click', function(e){
    var c = e.target.closest('.snf-buy__chip'); if (!c) return;
    var box = c.closest('[data-snf-buy]');
    var isSub = c.hasAttribute('data-sub-qty');
    box.querySelectorAll(isSub ? '.snf-buy__chip[data-sub-qty]' : '.snf-buy__chip[data-qty]').forEach(function(x){ x.classList.toggle('is-active', x === c); });
    var r = box.querySelector('input[value="' + (isSub ? 'sub' : 'once') + '"]'); if (r) r.checked = true;
    sync(box);
  });
  function init(){ document.querySelectorAll('[data-snf-buy]').forEach(sync); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
